/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { EquipperV5, EquipperV5Interface } from "../EquipperV5";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "equipmentContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "tournamentContractAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetsContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SETTINGS_UPDATER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "equipment",
    outputs: [
      {
        internalType: "contract IGameEquipment",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "equippings",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "int256",
        name: "hitPoints",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "attack",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "defense",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "percentChanceOfUse",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numberOfUsesPerGame",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "createdAt",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "gladiatorId",
        type: "uint256",
      },
    ],
    name: "gladiatorEquipment",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "int256",
            name: "hitPoints",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "attack",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "defense",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "percentChanceOfUse",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "numberOfUsesPerGame",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "createdAt",
            type: "bytes32",
          },
        ],
        internalType: "struct IGameEquipment.EquipmentMetadata[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "globaMaxPerTournamentGladiator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lockTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPerGladiator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPerTournament",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "playerEquippings",
    outputs: [
      {
        internalType: "uint256",
        name: "gladiatorId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "equipmentId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "playerTournamentCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "playerTournamentGladiatorCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_lockTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxPerGladiator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxPerTournament",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_globaMaxPerTournamentGladiator",
        type: "uint256",
      },
    ],
    name: "updateSettings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class EquipperV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    equipmentContract: string,
    tournamentContractAddress: string,
    assetsContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<EquipperV5> {
    return super.deploy(
      equipmentContract,
      tournamentContractAddress,
      assetsContract,
      overrides || {}
    ) as Promise<EquipperV5>;
  }
  getDeployTransaction(
    equipmentContract: string,
    tournamentContractAddress: string,
    assetsContract: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      equipmentContract,
      tournamentContractAddress,
      assetsContract,
      overrides || {}
    );
  }
  attach(address: string): EquipperV5 {
    return super.attach(address) as EquipperV5;
  }
  connect(signer: Signer): EquipperV5__factory {
    return super.connect(signer) as EquipperV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EquipperV5Interface {
    return new utils.Interface(_abi) as EquipperV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EquipperV5 {
    return new Contract(address, _abi, signerOrProvider) as EquipperV5;
  }
}
